import React from 'react'

export default function Footer() {
  return (
    <footer className='Footer'>
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-3">
            <h5 className='gold'>Телефон</h5>
            <a className='tel' href="tel:+998776998388">+998776998388</a> <br />

            <a className='tel' href="tel:+998705039909">+998705039909</a> <br />
          </div>
          <div className="middle col-md-4 mb-3">
           
          </div>
          <div className="col-md-4 mb-3">
            <h5 className="gold">Адрес :</h5>
            <p>Юнусабадский район, 7-й квартал, улица Майкургон, 49 (напротив кафе FeedUp, -1 этаж новостройки)</p>


          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2024 DAKO. Все права защищены.</p>

          <p>Разработка и реклама <a className='site' target='_blank' href="https://www.instagram.com/webmarketing.uz/">WEB MARKETING</a></p>
        </div>
      </div>
    </footer>
  )
}
